/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import type {
  Client,
  RequestConfig,
  ResponseErrorConfig,
} from "@/shared/api/axiosInstance";
import type {
  UseMutationOptions,
  UseMutationResult,
  QueryClient,
} from "@tanstack/react-query";
import type {
  PostApiV1PecegepayBilletCoursefinpersonpaymentidMutationResponse,
  PostApiV1PecegepayBilletCoursefinpersonpaymentidPathParams,
  PostApiV1PecegepayBilletCoursefinpersonpaymentidQueryParams,
  PostApiV1PecegepayBilletCoursefinpersonpaymentid400,
  PostApiV1PecegepayBilletCoursefinpersonpaymentid401,
  PostApiV1PecegepayBilletCoursefinpersonpaymentid404,
  PostApiV1PecegepayBilletCoursefinpersonpaymentid500,
} from "../../types/pecegePayBilletController/PostApiV1PecegepayBilletCoursefinpersonpaymentid.ts";
import { mutationOptions, useMutation } from "@tanstack/react-query";
import { postApiV1PecegepayBilletCoursefinpersonpaymentid } from "../../clients/pecegePayBilletController/postApiV1PecegepayBilletCoursefinpersonpaymentid.ts";

export const postApiV1PecegepayBilletCoursefinpersonpaymentidMutationKey = () =>
  [{ url: "/api/v1/pecegepay/billet/:courseFinPersonPaymentId" }] as const;

export type PostApiV1PecegepayBilletCoursefinpersonpaymentidMutationKey =
  ReturnType<
    typeof postApiV1PecegepayBilletCoursefinpersonpaymentidMutationKey
  >;

export function postApiV1PecegepayBilletCoursefinpersonpaymentidMutationOptions<
  TContext = unknown,
>(config: Partial<RequestConfig> & { client?: Client } = {}) {
  const mutationKey =
    postApiV1PecegepayBilletCoursefinpersonpaymentidMutationKey();
  return mutationOptions<
    PostApiV1PecegepayBilletCoursefinpersonpaymentidMutationResponse,
    ResponseErrorConfig<
      | PostApiV1PecegepayBilletCoursefinpersonpaymentid400
      | PostApiV1PecegepayBilletCoursefinpersonpaymentid401
      | PostApiV1PecegepayBilletCoursefinpersonpaymentid404
      | PostApiV1PecegepayBilletCoursefinpersonpaymentid500
    >,
    {
      courseFinPersonPaymentId: PostApiV1PecegepayBilletCoursefinpersonpaymentidPathParams["courseFinPersonPaymentId"];
      params?: PostApiV1PecegepayBilletCoursefinpersonpaymentidQueryParams;
    },
    TContext
  >({
    mutationKey,
    mutationFn: async ({ courseFinPersonPaymentId, params }) => {
      return postApiV1PecegepayBilletCoursefinpersonpaymentid(
        courseFinPersonPaymentId,
        params,
        config,
      );
    },
  });
}

/**
 * @description Registra um novo boleto no Pecege Pay para a parcela informada.
 * @summary Registrar boleto
 * {@link /api/v1/pecegepay/billet/:courseFinPersonPaymentId}
 */
export function usePostApiV1PecegepayBilletCoursefinpersonpaymentid<TContext>(
  options: {
    mutation?: UseMutationOptions<
      PostApiV1PecegepayBilletCoursefinpersonpaymentidMutationResponse,
      ResponseErrorConfig<
        | PostApiV1PecegepayBilletCoursefinpersonpaymentid400
        | PostApiV1PecegepayBilletCoursefinpersonpaymentid401
        | PostApiV1PecegepayBilletCoursefinpersonpaymentid404
        | PostApiV1PecegepayBilletCoursefinpersonpaymentid500
      >,
      {
        courseFinPersonPaymentId: PostApiV1PecegepayBilletCoursefinpersonpaymentidPathParams["courseFinPersonPaymentId"];
        params?: PostApiV1PecegepayBilletCoursefinpersonpaymentidQueryParams;
      },
      TContext
    > & { client?: QueryClient };
    client?: Partial<RequestConfig> & { client?: Client };
  } = {},
) {
  const { mutation = {}, client: config = {} } = options ?? {};
  const { client: queryClient, ...mutationOptions } = mutation;
  const mutationKey =
    mutationOptions.mutationKey ??
    postApiV1PecegepayBilletCoursefinpersonpaymentidMutationKey();

  const baseOptions =
    postApiV1PecegepayBilletCoursefinpersonpaymentidMutationOptions(
      config,
    ) as UseMutationOptions<
      PostApiV1PecegepayBilletCoursefinpersonpaymentidMutationResponse,
      ResponseErrorConfig<
        | PostApiV1PecegepayBilletCoursefinpersonpaymentid400
        | PostApiV1PecegepayBilletCoursefinpersonpaymentid401
        | PostApiV1PecegepayBilletCoursefinpersonpaymentid404
        | PostApiV1PecegepayBilletCoursefinpersonpaymentid500
      >,
      {
        courseFinPersonPaymentId: PostApiV1PecegepayBilletCoursefinpersonpaymentidPathParams["courseFinPersonPaymentId"];
        params?: PostApiV1PecegepayBilletCoursefinpersonpaymentidQueryParams;
      },
      TContext
    >;

  return useMutation<
    PostApiV1PecegepayBilletCoursefinpersonpaymentidMutationResponse,
    ResponseErrorConfig<
      | PostApiV1PecegepayBilletCoursefinpersonpaymentid400
      | PostApiV1PecegepayBilletCoursefinpersonpaymentid401
      | PostApiV1PecegepayBilletCoursefinpersonpaymentid404
      | PostApiV1PecegepayBilletCoursefinpersonpaymentid500
    >,
    {
      courseFinPersonPaymentId: PostApiV1PecegepayBilletCoursefinpersonpaymentidPathParams["courseFinPersonPaymentId"];
      params?: PostApiV1PecegepayBilletCoursefinpersonpaymentidQueryParams;
    },
    TContext
  >(
    {
      ...baseOptions,
      mutationKey,
      ...mutationOptions,
    },
    queryClient,
  ) as UseMutationResult<
    PostApiV1PecegepayBilletCoursefinpersonpaymentidMutationResponse,
    ResponseErrorConfig<
      | PostApiV1PecegepayBilletCoursefinpersonpaymentid400
      | PostApiV1PecegepayBilletCoursefinpersonpaymentid401
      | PostApiV1PecegepayBilletCoursefinpersonpaymentid404
      | PostApiV1PecegepayBilletCoursefinpersonpaymentid500
    >,
    {
      courseFinPersonPaymentId: PostApiV1PecegepayBilletCoursefinpersonpaymentidPathParams["courseFinPersonPaymentId"];
      params?: PostApiV1PecegepayBilletCoursefinpersonpaymentidQueryParams;
    },
    TContext
  >;
}
